import styled from "styled-components";

import { SpotlightCard } from "./components";

import { SpotlightBrandAssetGroupFragment } from "@otta/search/schema";
import { palette, pxToRem } from "@otta/design-tokens";
import { Heading, Text, media } from "@otta/design";
import { Asset } from "@otta/search/components/AssetSprinkler/Asset";
import { OttaIcons } from "@otta/icons";

const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${pxToRem(8)};

  ${media({ to: "tablet" })`
    flex-direction: column;
  `}
`;

const DesktopAsset = styled(Asset)`
  ${media({ to: "tablet" })`
  display: none;
`}
`;

const BenefitInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(8)};

  ${media({ from: "desktop" })`
    max-width: ${pxToRem(226)};
    flex-grow: 1;
  `}
`;

export function Benefits({
  assetGroup,
}: {
  assetGroup: SpotlightBrandAssetGroupFragment;
}) {
  const spotlightBenefit = assetGroup.links[0];
  const spotlightTag = {
    icon: OttaIcons["NewToOtta"],
    text: "Benefits",
    color: palette.brand.orange,
  };

  return (
    <SpotlightCard testID="benefits-asset-card" tag={spotlightTag}>
      <Content>
        <DesktopAsset asset={spotlightBenefit} />
        <BenefitInfo>
          <Heading size={2}>
            {spotlightBenefit.companyBrandAsset.shortTitle}
          </Heading>
          <Text size={-1}>{spotlightBenefit.companyBrandAsset.longTitle}</Text>
        </BenefitInfo>
      </Content>
    </SpotlightCard>
  );
}
